export default class Component {
    constructor(data) {
        Object.assign(this, data)

        this.general = new ComponentInfo(data.general)
    }

    getInfo() {
        return this.general
    }

    getRef() {
        return this.general.getRef()
    }

    /**
     * Get all fields including extension fields from a component object
     * @param {Object} component - Component object (can be plain object or Component instance)
     * @returns {Array} Array of all fields
     */
    getAllFields() {
        const regularFields = this.settings && this.settings.fields ? this.settings.fields : []
        const extensionFields = this.getExtensionFields()
        
        return [...regularFields, ...extensionFields]
    }

    /**
     * Get fields from active extensions from a component object
     * @param {Object} component - Component object (can be plain object or Component instance)
     * @returns {Array} Array of extension fields
     */
    getExtensionFields() {
        if (!this.settings || !this.settings.extensions) {
            return []
        }

        const extensionFields = []
        const extensions = this.settings.extensions || []

        extensions.forEach(extension => {
            if (extension.is_active && extension.fields) {
                extension.fields.forEach(field => {
                    // Store the original key and create a nested key for data binding
                    const originalKey = field.key
                    extensionFields.push({
                        ...field,
                        key: `extensions.${extension.name}.${originalKey}`,
                        originalKey: originalKey,
                        extensionName: extension.name,
                        isExtensionField: true
                    })
                })
            }
        })

        return extensionFields
    }

    /**
     * Static method to get extension fields from a component
     * @param {Object} component - Component object or Component instance
     * @returns {Array} Array of extension fields
     */
    static getExtensionFields(component) {
        if (component instanceof Component) {
            return component.getExtensionFields()
        }
        
        if (!component.settings || !component.settings.extensions) {
            return []
        }

        const extensionFields = []
        component.settings.extensions.forEach(extension => {
            if (extension.is_active && extension.fields && Array.isArray(extension.fields)) {
                extension.fields.forEach(field => {
                    const originalKey = field.key
                    extensionFields.push({
                        ...field,
                        key: `extensions.${extension.name}.${originalKey}`,
                        originalKey: originalKey,
                        extensionName: extension.name,
                        isExtensionField: true
                    })
                })
            }
        })

        return extensionFields
    }

    /**
     * Static method to get all fields including extension fields
     * @param {Object} component - Component object or Component instance
     * @returns {Array} Array of all fields
     */
    static getAllFields(component) {
        if (component instanceof Component) {
            return component.getAllFields()
        }
        
        const regularFields = component.settings && component.settings.fields ? component.settings.fields : []
        const extensionFields = Component.getExtensionFields(component)
        
        return [...regularFields, ...extensionFields]
    }
}

export class ComponentInfo {
    constructor(data) {
        Object.assign(this, data)
    }

    getRef() {
        let value = this.name
        if (this.scope && this.scope != '') {
            value = `${this.scope}::${this.name}`
        }

        return value
    }
}